import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../_services/AdminService.service';
import { ActivatedRoute } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { AuthServiceService } from '../_services/AuthService.service';

@Component({
  selector: 'app-liveapi',
  templateUrl: './liveapi.component.html',
  styleUrls: ['./liveapi.component.css']
})
export class LiveapiComponent implements OnInit {

  apiInfo: any;

  constructor(private _adminService: AdminServiceService, private _route: ActivatedRoute, 
    private _alertify: AlertifyService, private _authService: AuthServiceService) { }

  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.loadApiInfo(params["id"]);
    });    

  }

  private loadApiInfo(apiId) {
    this._adminService.getApiDetails(apiId).subscribe(details => {
      this.apiInfo = details;
    }, error => {
      this._alertify.error(error);
    });
  }

}
